import * as Icons from "@nova/component-icons"

export enum MapSearchFeatureType {
    Country,
    State,
    City,
    Address,
    Other,
}

export const mapSearchIcon = (featureType: string) => {
    switch (featureType) {
        case "country":
            return Icons.LocationCountry
        case "region":
        case "subregion":
            return Icons.LocationState
        case "county":
        case "joint_municipality":
        case "joint_submunicipality":
        case "municipality":
        case "municipal_district":
        case "locality":
            return Icons.LocationCity
        case "neighbourhood":
        case "place":
        case "postal_code":
        case "address":
        case "road":
            return Icons.LocationAddress
        default:
            return Icons.LocationCatchAll
    }
}

export const mapSearchKeywords = ["location", "layer", "coordinate"]
export const mapSearchLargestKeyword = mapSearchKeywords.reduce((largest, current) => {
    if (current.length > largest.length) largest = current
    return largest
}, "")
